<template>
  <div class="Tender" style="position:fixed">


      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">

                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>AIIB</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" style="height:75vh; overflow-y:scroll;width:99vw">
            <div class="cntnt">

          <div id="Fin1">
            <b-row>
              <b-col cols="12">
                  <h1 class="heading">AIIB Projects</h1>
              </b-col>

           </b-row>
           <p class="content">
             <b-overlay
               :show="show"
               spinner-variant="primary"
               spinner-large
               rounded="sm"
               style="height:100vh"
               variant="dark"
               id="loader"
             >
              <b-table    :items="aiibProject" :fields="aiibProjectFields">
                <template v-slot:cell(description)="data">
                 <span   v-html="data.value"></span>
                </template>
                <template v-slot:cell(tender_no)="data">
                 <span   v-html="data.value"></span>
                </template>
                <template v-slot:cell(important_dates)="data">
                  <span   v-html="data.value"></span>
                </template>



                <!--
                <template v-slot:cell(Important_Dates)="data">
                  <span   v-html="data.value"></span>
                </template> -->
              </b-table>
              </b-overlay>
            </p>
          </div>

          </div>
          </b-col>
        </b-row>
      </b-container>
      <br><br>

  </div>
</template>



<script>
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import axios from 'axios'


const URL = "https://www.apdcl.org/website";

export default {

  components: {
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
    },
  data() {
      return {
        aiibProjectFields: [
          { key: 'description', label: 'Description',thStyle: {width: '40vw'} },
          { key: 'tender_no', label: 'Tender Number',thStyle: {width: '30vw'} },
          { key: 'important_dates', label: 'Important Dates',thStyle: {width: '20vw'} }
        ],
        aiibProject : [],
        show:false
      }

  },
  mounted1()
  {

      var temp = [];

      var style="";
      var parent=this;
      this.show=true;
        axios.get(this.$urlCommon+ "/api/aiibProject").then(response =>
          {
            console.log(response.data.aiibProject);
            this.show=false;
            var data = response.data.aiibProject;

            data.forEach(element => {

          if(element.file_location != null)
            {
              var doc_l = element.file_location.split("|")
              var doc_t = element.type.split("|")
              var date = element.date.split("|")
              var desc = "<br>";
              var dated="";
            for(var i=0; i<doc_l.length; i++)
            {
              if(doc_t[i] == 'Cancellation')
                break;
              if(date[i] != "NA")
                dated = "( Dated " + date[i] +")" ;

              desc = desc  + "<span> <a " + style + " target='_blank' href='" + doc_l[i] +"'><img src='assets/pdf-icon-3.png' height='30px' width='30px' />" + doc_t[i] + dated +"</a><br></span>"
            }
          }
          else {
            desc="";
          }
          var download_text= (element.tender_no == "NA") ?"Download":"Notice Inviting Tender";
              var obj = {
              "description" :  element.description
              + "<br><br><a " + style + " target='_blank' href='" + element.nit +"'><img src='assets/pdf-icon-3.png' height='30px' width='30px' />"+download_text+" </a>"
              + desc,
              "tender_no" : "<span style='color: #424242; font-weight:600 '>" + element.tender_no + "</span>",
              "important_dates" : "<strong>Tender Date : </strong> " + element.tender_date

            //  "important_dates" : "<strong>Tender Date : </strong> " + element.tender_date + "<br><strong>Pre Bid Meeting Date : </strong> " + element.prebid_date + "<br><strong>Bid Start Date : </strong> " + element.bid_start_date + "<br><strong>Bid End Date : </strong>" + element.bid_end_date + "<br><strong>Bid Opening Date : </strong>" + element.bid_opening_date
              }
             temp.push(obj);
            })
            parent.aiibProject = temp;

        })

      },
      mounted()
      {
        var temp = [];
        this.show=true;
        var parent=this;
          axios.get(this.$urlCommon+ "/api/aiibProject").then(response =>
            {
              console.log(response.data.aiibProject);
              this.show=false;
              var data = response.data.aiibProject;

      data.forEach(element => {
        var style="";
        var newImg="";

        if(element.new_flag== "Y")
          newImg = "<img src='"+URL+"/assets/new.gif' />";


      if(element.file_location != null)
        {
          var doc_l = element.file_location.split("|")
          var doc_t = element.type.split("|")
          var date = element.date.split("|")
          var title = element.title.split("|")
          var new_flag = element.new_flag_doc.split("|")
          var desc = "<br>";
          var dated="";
          var newImgDoc=""

        for(var i=0; i<doc_l.length; i++)
        {
          if(doc_t[i] == 'Cancellation')
          break;
          if(date[i] != "NA")
            dated = "( Dated " + date[i] +")" ;

            if(new_flag[i] == "Y")
              newImgDoc = "<img src='"+URL+"/assets/new.gif' />" ;

          desc = desc  + "<span> <a " + style + " target='_blank' href='" + doc_l[i] +"'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' />" + doc_t[i]+ " : "+ title[i] + dated + "</a>"+newImgDoc+"<br></span>"
        }
      }
      else {
        desc="";
      }
      var download_text= (element.tender_no == "NA") ?"Download":"Notice Inviting Tender";
          //console.log(desc);
        var obj = {
          "description" :  element.description
          + "<br><br><a " + style + " target='_blank' href='" + element.nit +"'><img src='"+URL+"/assets/pdf-icon-3.png' height='30px' width='30px' />"+download_text+"</a>"+newImg
          + desc,
          "tender_no" : "<span style='color: #424242; font-weight:600 '>" + element.tender_no + "</span>",
          "important_dates" : "<strong>Tender Date : </strong> " + element.tender_date + "<br><strong>Pre Bid Meeting Date : </strong> " + element.prebid_date + "<br><strong>Bid Submission Start Date : </strong> " + element.bid_start_date + "<br><strong>Bid Submission End Date : </strong>" + element.bid_end_date + "<br><strong>Bid Opening Date : </strong>" + element.bid_opening_date
          }
         temp.push(obj);

        })
        console.log(temp);
        parent.aiibProject = temp;
      })
}
}
</script>

<style scoped="true">
li{
  padding:0;
}

    body{
      overflow-y:hidden;
    }
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}
.content{
    text-align: justify;
line-height: 1.5rem;
font-size:0.9rem;
}
.cntnt{
/* box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);*/
padding:10px 30px 10px 30px;
}

table{
  text-align: left !important;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .cntnt{
      padding: 0px;
      width:200vw;
    }
  }

</style>
